module.exports = __webpack_public_path__ + "static/assets/18ec610c4e29d83d214a7e844b836cd8.jpg";